import { h } from 'preact';
import { ListEntry } from '@epx/flow';

const SUB_PROCESS_TYPES = ['epx:SubProcess', 'epx:Transaction'];

const getSubTypes = (i18n) => [
  { value: '', label: i18n['opt.none'] || '-- None --' },
  { value: 'CallActivity', label: i18n['opt.CallActivity'] || 'Call Activity' },
  { value: 'SubProcess', label: i18n['opt.SubProcess'] || 'Sub-Process' },
];

export class SfdSubProcessExtension {
  constructor(lf, i18n) {
    this._lf = lf;
    this._i18n = i18n;
  }

  isApplicable(elementType) {
    return SUB_PROCESS_TYPES.includes(elementType);
  }

  getGroups(element) {
    const lf = this._lf;
    const i18n = this._i18n;
    const props = element.properties || {};
    const id = element.id;

    const columns = [
      { key: 'subProcessName', label: i18n.name || 'Name', width: '28%' },
      { key: 'subProcessGUID', label: 'GUID', width: '22%' },
      { key: 'subType', label: i18n.type || 'Type', type: 'select', options: getSubTypes(i18n), width: '18%' },
      { key: 'subId', label: 'Var (parent)', width: '16%' },
      { key: 'subVar', label: 'Var (sub)', width: '16%' },
    ];

    const subInfoes = props.subInfoes || [];

    const updateSubInfoes = (items) => {
      lf.setProperties(id, { subInfoes: items });
      lf.emit('node:properties-change', { id, properties: { subInfoes: items } });
    };

    return [
      {
        id: 'sfdSubProcess',
        label: i18n.sfdSubInfoes || 'Sub-Process Info',
        entries: [
          {
            id: 'subInfoesList',
            component: () => (
              <ListEntry
                id="sfd-subInfoes"
                label=""
                items={subInfoes}
                columns={columns}
                onAdd={() =>
                  updateSubInfoes([...subInfoes, { subProcessName: '', subProcessGUID: '', subType: '', subId: '', subVar: '' }])
                }
                onRemove={(idx) => updateSubInfoes(subInfoes.filter((_, i) => i !== idx))}
                onChange={(idx, key, value) => {
                  const updated = subInfoes.map((s, i) => (i === idx ? { ...s, [key]: value } : s));
                  updateSubInfoes(updated);
                }}
              />
            ),
          },
        ],
      },
    ];
  }
}
